import assign from 'object-assign';
import {combineReducers} from 'redux';
import uuid from 'uuid/v4';
import {
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_EMAIL_ADDRESS,
  SET_MOBILE_PHONE,
  SET_DATE_OF_BIRTH,
  SET_GROUP_ID,
  SET_GENDER,
  SET_MARITAL_STATUS,
  SET_GUEST,
  SET_FIRST_NAME_ERRORS,
  SET_LAST_NAME_ERRORS,
  SET_EMAIL_ADDRESS_ERRORS,
  SET_MOBILE_PHONE_ERRORS,
  SET_DATE_OF_BIRTH_ERRORS,
  SET_GROUP_ID_ERRORS,
  SET_GENDER_ERRORS,
  SET_MARITAL_STATUS_ERRORS,
  SET_GUEST_ERRORS,
  ADD_FAMILY_MEMBER,
  REMOVE_FAMILY_MEMBER
} from '../actionTypes/familyMembers';
import {
  SET_LAST_NAME as ME_SET_LAST_NAME
} from '../actionTypes/me';


function makeFamilyMember() {
  return {
    First_Name: {
      value: null,
      errors: ['This field is required.']
    },
    Last_Name: {
      value: null,
      errors: ['This field is required.']
    },
    Date_of_Birth: {
      value: null,
      errors: ['This field is required.']
    },
    Gender_ID: {
      value: null,
      errors: ['This field is required.']
    },
    Group_ID: {
      value: null,
      errors: []
    },
    Guest: {
      value: false,
      errors: []
    }
  };
}


function updateFamilyMember(id, state, values) {
  let familyMember = assign({}, state[id]);

  for (let i in values) {
    if (values.hasOwnProperty(i)) {
      familyMember[i].value = values[i];
    }
  }

  return assign({}, state, {
    [id]: familyMember
  });
}


function updateFamilyMemberErrors(id, state, values) {
  let familyMember = assign({}, state[id]);

  for (let i in values) {
    if (values.hasOwnProperty(i)) {
      familyMember[i].errors = values[i];
    }
  }

  return assign({}, state, {
    [id]: familyMember
  });
}


export default combineReducers({
  ids(state = [], action) {
    switch (action.type) {
      case ADD_FAMILY_MEMBER:
        return [
          ...state,
          action.id
        ];
      case REMOVE_FAMILY_MEMBER:
        let idx = state.indexOf(action.id);
        if (idx !== -1) {
          state = state.slice();
          state.splice(idx, 1);
        }
        return state;
      default:
        return state;
    }
  },
  byId(state = {}, action) {
    switch (action.type) {
      case ADD_FAMILY_MEMBER:
        return assign({}, state, {
          [action.id]: makeFamilyMember()
        });
      case REMOVE_FAMILY_MEMBER:
        state = assign({}, state);
        delete state[action.id];
        return state;
      case SET_FIRST_NAME:
        return updateFamilyMember(action.id, state, {
          First_Name: action.value
        });
      case SET_LAST_NAME:
        return updateFamilyMember(action.id, state, {
          Last_Name: action.value
        });
      case SET_DATE_OF_BIRTH:
        return updateFamilyMember(action.id, state, {
          Date_of_Birth: action.value
        });
      case SET_GROUP_ID:
        return updateFamilyMember(action.id, state, {
          Group_ID: action.value
        });
      case SET_GENDER:
        return updateFamilyMember(action.id, state, {
          Gender_ID: action.value
        });
      case SET_GUEST:
        return updateFamilyMember(action.id, state, {
          Guest: action.value
        });
      case SET_FIRST_NAME_ERRORS:
        return updateFamilyMemberErrors(action.id, state, {
          First_Name: action.errors
        });
      case SET_LAST_NAME_ERRORS:
        return updateFamilyMemberErrors(action.id, state, {
          Last_Name: action.errors
        });
      case SET_DATE_OF_BIRTH_ERRORS:
        return updateFamilyMemberErrors(action.id, state, {
          Date_of_Birth: action.errors
        });
      case SET_GROUP_ID_ERRORS:
        return updateFamilyMemberErrors(action.id, state, {
          Group_ID: action.errors
        });
      case SET_GENDER_ERRORS:
        return updateFamilyMemberErrors(action.id, state, {
          Gender_ID: action.errors
        });
      case SET_GUEST_ERRORS:
        return updateFamilyMemberErrors(action.id, state, {
          Guest: action.errors
        });
      default:
        return state;
    }
  }
});


// WEBPACK FOOTER //
// ./src/reducers/familyMembers.js